import { Box, Link, Typography } from '@mui/material';
import SurveyUtils from '../../shared/SurveyUtils';
import { constants } from '../../constants/constants';
import React, { FC, MouseEvent, useContext, useState } from 'react';
import { Theme } from '@mui/material/styles/createTheme';
import { LocalTranslationContext } from '../../hooks/useLocalTranslation';
import { useTranslation } from 'react-i18next';
import SurveyService from '../../services/SurveyService';
import { useIsSurveyPreview } from '../../hooks/useIsSurveyPreview';

interface Props {
  surveyId: string;
  surveyType: string;
  platformUrl: string;
  platformName?: string;
  platform: string;
  primary: string;
  theme: Theme;
  customFont?: string;
}

export const SurveyRateUsButton: FC<Props> = ({
  surveyId,
  surveyType,
  platformUrl,
  platformName,
  platform,
  primary,
  theme,
  customFont,
}) => {
  const localContext = useContext(LocalTranslationContext);
  const { t: globalT } = useTranslation('customSurvey');
  const t = localContext ? localContext.t : globalT;
  const [isNavigating, setIsNavigating] = useState(false);
  const isPreview = useIsSurveyPreview();

  const handlePlatformClick = async (event: MouseEvent<HTMLAnchorElement>) => {
    if (!surveyId || !surveyType || !platformUrl || isNavigating) {
      return;
    }

    event.preventDefault();
    setIsNavigating(true);

    try {
      if (!isPreview) {
        await SurveyService.saveSurveyPlatformClickBeforeNavigation(
          surveyId,
          surveyType,
          platformUrl
        );
      }
    } finally {
      window.location.assign(platformUrl);
    }
  };

  if (!platform) {
    return <></>;
  }

  return (
    <>
      <Link
        className="survey-rate-us-link survey-rate-us-link--button"
        href={platformUrl}
        onClick={handlePlatformClick}
        underline={'none'}
        sx={{ pointerEvents: isNavigating ? 'none' : 'auto' }}
      >
        <Typography
          className="survey-rate-us-button"
          variant="h5"
          sx={{
            color: '#fff',
            backgroundColor: primary,
            padding: '.2em .5em',
            fontWeight: 'light',
            borderRadius: '4px',
            boxShadow:
              'rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px;',
            mt: theme.spacing(4),
            '&:hover': {
              opacity: 0.9,
            },
          }}
        >
          {platform !== 'others' &&
            SurveyUtils.getName(platformName) &&
            `${t('please_rate_us')} ${SurveyUtils.getName(platformName)}!`}
          {platform !== 'others' && !SurveyUtils.getName(platformName) && `${t('please_rate_us')}`}
          {platform === 'others' && `${t('please_rate_us_no_platform')}`}
        </Typography>
      </Link>
      <Link
        className="survey-rate-us-link survey-rate-us-link--logo"
        href={platformUrl}
        onClick={handlePlatformClick}
        variant="body1"
        underline="none"
        sx={{
          pointerEvents: isNavigating ? 'none' : 'auto',
          color: primary,
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        {constants.platform_logos[platform.toLowerCase()] ? (
          <Box
            className="survey-rate-us-logo"
            component={'img'}
            sx={{
              width: '100%',
              maxWidth: '256px',
              height: 'auto',
              minHeight: '64px',
              mt: theme.spacing(4),
              mb: theme.spacing(2),
            }}
            src={constants.platform_logos[platform.toLowerCase()]}
            alt={`${platform} Logo`}
          />
        ) : (
          <></>
        )}
      </Link>
    </>
  );
};
